import { IIcon } from '../interfaces'

const SvgComponent = ({ width = 20, height = 20, size, ...props }: IIcon) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 18 18'
    width={size || width}
    height={size || height}
    {...props}
  >
    <path fill='currentColor' d='M9 10.99 5.697 7.688h6.606z' />
  </svg>
)
export default SvgComponent
